import React from "react"; // eslint-disable-line no-unused-vars
import styled from "styled-components";
import Loader from "./loading.svg";

import TimeIndicator from "./TimeIndicator";
const GRIDGAP = "0px";
const SLOT_HEIGHT = "25px";

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.5);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;
const CssGrid = styled.div`
  width: 100%;
  display: grid;
  position: relative;
  //border-left: 1px solid #eee;
  //border-bottom: 1px solid #eee;
  grid-gap: ${GRIDGAP};
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAOUlEQVQoU43KSQ4AIAgDQPn/o2tKonGhwJzHRgMAWPU8URZX4pHxTDK+KYxR+qJKV8zSjlXy2EmMEw3rKAc0w09vAAAAAElFTkSuQmCC)
    repeat;
  background-color: #ccc;
  grid-template-columns:
    50px
    repeat(
      ${(props) => props.cols},
      calc((100% - 49px) / ${(props) => props.cols})
    );
  grid-template-rows: repeat(${(props) => props.rows}, ${SLOT_HEIGHT});
  grid-auto-flow: column;
  margin-top: ${(props) => props.marginTop};
`;

class Grid extends React.Component {
  render() {
    return (
      <CssGrid
        rows={this.props.nbrRows}
        cols={this.props.nbrCols}
        marginTop={this.props.marginTop}
      >
        {this.props.loading ? (
          <Overlay>
            <img
              alt="Loading"
              style={{
                width: "50px",
                marginTop: "50px",
              }}
              src={Loader}
            />
          </Overlay>
        ) : null}

        <TimeIndicator
          minTime={this.props.minTime}
          maxTime={this.props.maxTime}
          baseDuration={this.props.baseDuration}
        />

        {this.props.timeColumn}
        {this.props.columns}
      </CssGrid>
    );
  }
}

export default Grid;



// WEBPACK FOOTER //
// ./src/components/utilities/calendar/Grid.js